import { render, staticRenderFns } from "./ObjektiCard2Tab-4-Posete.vue?vue&type=template&id=b0103e08&scoped=true&"
import script from "./ObjektiCard2Tab-4-Posete.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-4-Posete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0103e08",
  null
  
)

export default component.exports